import { EVENTMODAL, GUESTSMODAL } from "../actions/modalAction";

const default_modal_value = {
    state: false
}


const modalReducer = (state = default_modal_value, action) => {
    switch (action.type) {
        case EVENTMODAL: {
            return {
                eventModalState: action.state,
                guestsModalState: false
            }
        }
        case GUESTSMODAL: {
            return {
                guestsModalState: action.state,
                eventModalState: true
            }
        }
        default: return state;
    }
}

export default modalReducer